var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "lock",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.748,
    height: 48.748,
    viewBox: "0 0 48.748 48.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.9,19.3a1.534,1.534,0,0,1-1.523-1.523V13.71c0-6.4-1.808-10.664-10.664-10.664S3.047,7.312,3.047,13.71v4.062A1.534,1.534,0,0,1,1.523,19.3,1.534,1.534,0,0,1,0,17.773V13.71C0,7.82,1.422,0,13.71,0s13.71,7.82,13.71,13.71v4.062A1.534,1.534,0,0,1,25.9,19.3Z",
    transform: "translate(10.664 2.539)",
    fill: "#ef7a30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M31.991,27.421H11.679C2.722,27.421,0,24.7,0,15.741V11.679C0,2.722,2.722,0,11.679,0H31.991C40.948,0,43.67,2.722,43.67,11.679v4.062C43.67,24.7,40.948,27.421,31.991,27.421ZM11.679,3.047c-7.272,0-8.632,1.381-8.632,8.632v4.062c0,7.251,1.361,8.632,8.632,8.632H31.991c7.272,0,8.632-1.381,8.632-8.632V11.679c0-7.251-1.361-8.632-8.632-8.632H11.679Z",
    transform: "translate(2.539 18.788)",
    fill: "#ef7a30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M2.031,4.06A2.022,2.022,0,0,1,1.259,3.9a2.1,2.1,0,0,1-.67-.427A2.1,2.1,0,0,1,0,2.029a2.022,2.022,0,0,1,.162-.772A2.1,2.1,0,0,1,.589.587,2.1,2.1,0,0,1,1.259.16,2.036,2.036,0,0,1,3.473.587a2.345,2.345,0,0,1,.427.67,2.022,2.022,0,0,1,.162.772,2.136,2.136,0,0,1-.589,1.442A2.136,2.136,0,0,1,2.031,4.06Z",
    transform: "translate(14.218 30.47)",
    fill: "#ef7a30"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M2.031,4.064A2.136,2.136,0,0,1,.589,3.475,2.1,2.1,0,0,1,0,2.033a1.7,1.7,0,0,1,.162-.772A2.345,2.345,0,0,1,.589.591,2.028,2.028,0,0,1,2.417.042,1.225,1.225,0,0,1,2.8.164a1.538,1.538,0,0,1,.366.183,3.2,3.2,0,0,1,.3.244,2.345,2.345,0,0,1,.427.67,2.022,2.022,0,0,1,.162.772,2.1,2.1,0,0,1-.589,1.442l-.3.244A1.538,1.538,0,0,1,2.8,3.9a1.225,1.225,0,0,1-.386.122A2.489,2.489,0,0,1,2.031,4.064Z",
    transform: "translate(22.343 30.466)",
    fill: "#ef7a30"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M2.031,4.064A2.1,2.1,0,0,1,.589,3.475,2.345,2.345,0,0,1,.162,2.8,2.022,2.022,0,0,1,0,2.033,2.136,2.136,0,0,1,.589.591l.3-.244A1.538,1.538,0,0,1,1.259.164,1.291,1.291,0,0,1,1.625.042,2.067,2.067,0,0,1,3.473.591a2.1,2.1,0,0,1,.589,1.442A2.022,2.022,0,0,1,3.9,2.8a2.1,2.1,0,0,1-.427.67A2.136,2.136,0,0,1,2.031,4.064Z",
    transform: "translate(30.467 30.466)",
    fill: "#ef7a30"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-6",
    "data-name": "Vector",
    d: "M0,0H48.748V48.748H0Z",
    fill: "none",
    opacity: 0
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.a4234854e17e04c1fb1f08d327391f1d.svg";
export { ForwardRef as ReactComponent };